import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import img1 from "../assets/Contactless1.jpg";
import img2 from "../assets/smart_facility_monitor_system.png";

const SmartFacilityMonitoringSystem = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const navigate = useNavigate();
    const items = [

        {
            title: "Smart Dustbin Monitoring System",
            desc: "Fill-level sensing and route optimization for efficient waste collection.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-3 0V4a2 2 0 00-2-2h-2a2 2 0 00-2 2v4m4 6h.01" />
                </svg>
            ),
        },
        {
            title: "Indoor Air Quality Monitoring System",
            desc: "Monitor CO2, PM2.5, VOCs and environmental data with cloud reporting.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15.362 5.214A8.05 8.05 0 0112 21 8.003 8.003 0 017.26 5.214m11.102 0a8.05 8.05 0 1-11.102 11.572M15.362 5.214l1.415-1.414" />
                </svg>
            ),
        },
        {
            title: "Occupancy Counting System",
            desc: "Real-time people counting and occupancy analytics for safe spaces.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.856-1.487M15 7a3 3 0 11-6 0 3 3 0 016 0zM15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
        }
    ];
    const [filter, setFilter] = useState("All");
    const filtered = useMemo(
        () => (filter === "All" ? items : items.filter((x) => x.type === filter)),
        [filter, items]
    );

    return (
        <div className="App">
            <div className="container py-5 main-content" style={{ marginTop: "50px" }}>
                <h1>Smart Facility Monitoring System</h1>

                <p className="lead">
                    The Smart Facility Monitoring System is an integrated IoT-based solution designed
                    to enhance visibility, efficiency, and safety across facilities. It connects multiple
                    smart devices — such as Smart Dustbins, Indoor Air Quality Monitors, and Occupancy
                    Counters — to a unified cloud dashboard. Facility managers can monitor real-time
                    data, receive instant alerts, and optimize maintenance schedules with data-driven
                    insights.
                </p>

                <div className="row my-4">

                    <div className="col-md-12 mb-5 d-flex justify-content-center">
                        <div className="img-card h-100 d-flex align-items-center justify-content-center">
                            <img
                                src={img2}
                                alt="Smart Facility Monitoring System Image 2"
                                className="img-fluid rounded shadow"
                                style={{ maxHeight: "400px", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row g-4 justify-content-center">
                    {filtered.map((it, idx) => (
                        <div key={idx} className="col-12 col-sm-10 col-md-6 col-lg-4 col-xl-3">
                            <div
                                className="card h-100 product-card border-0"
                                style={{
                                    background: "var(--card)",
                                    borderRadius: "16px",
                                    border: "1px solid var(--cardborder)",
                                    cursor: (it.title === "Smart Dustbin Monitoring System" || it.title === "Indoor Air Quality Monitoring System" || it.title === "Occupancy Counting System") ? "pointer" : "default",
                                }}
                                onClick={() => {
                                    if (it.title === "Smart Dustbin Monitoring System") {
                                        navigate("/products/smart-dustbin-monitoring-system");
                                    } else if (it.title === "Indoor Air Quality Monitoring System") {
                                        navigate("/products/indoor-air-quality-monitoring-system");
                                    } else if (it.title === "Occupancy Counting System") {
                                        navigate("/products/occupancy-counting-system");
                                    }
                                }}
                            >

                                <div className="card-body d-flex flex-column text-center p-4 p-md-4 p-lg-4">
                                    {/* Icon */}
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-3 mb-4 icon-container mx-auto"
                                        style={{
                                            width: "64px",
                                            height: "64px",
                                            background: "var(--chip)",
                                            color: "var(--primary)",
                                            flexShrink: 0,
                                        }}
                                    >
                                        {it.icon}
                                    </div>

                                    {/* Type badge */}
                                    <span
                                        className="badge rounded-pill px-3 py-2 mb-3"
                                        style={{
                                            background: "var(--chipalt)",
                                            color: "var(--chiptext)",
                                            fontSize: "0.75rem",
                                        }}
                                    >
                                        {it.title}
                                    </span>

                                    {/* Description */}
                                    <p className="mb-0 flex-grow-0" style={{ color: "var(--secondarytext)", opacity: 0.8, fontSize: "0.95rem" }}>
                                        {it.desc}
                                    </p>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Styles */}
                <style>{`
                    .product-card {
                        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
                        transition: all 0.3s ease;
                    }
                    .product-card:hover {
                        transform: translateY(-8px);
                        box-shadow: 0 16px 40px rgba(0, 0, 0, 0.1);
                        border-color: var(--primary) !important;
                    }
                    .product-card:hover .icon-container {
                        background: var(--primary) !important;
                        color: white !important;
                        transform: scale(1.05);
                    }
                    .icon-container {
                        transition: all 0.3s ease;
                    }
                    @media (max-width: 768px) {
                        .display-md-5 {
                            font-size: 2.5rem;
                        }
                    }
                    @media (prefers-reduced-motion: reduce) {
                        .product-card, .icon-container { 
                            transition: none; 
                        }
                        .product-card:hover {
                            transform: none;
                        }
                    }
                    .img-card {
                        background: #f8fafc;
                        border: 1px solid #e3e8ee;
                        border-radius: 16px;
                        padding: 24px;
                        box-shadow: 0 4px 24px rgba(25, 118, 210, 0.07);
                        transition: box-shadow 0.2s, transform 0.2s;
                        min-height: 260px;
                    }
                    .img-card:hover {
                        box-shadow: 0 8px 32px rgba(25, 118, 210, 0.15);
                        transform: translateY(-4px) scale(1.02);
                    }
                `}</style>

            </div>
            <Footer />
        </div>
    );
};

export default SmartFacilityMonitoringSystem;
